import classNames from 'classnames'
import CustomBottomSheet from 'components/bottomSheet'
import CustomDropDown from 'components/dropDown'
import ChangeShareModal from 'components/modals/changeShare'
import { Formik, Form } from 'formik'
import { useEffect, useState } from 'react'
import { NumericFormat } from 'react-number-format'
import { useNavigate, useParams } from 'react-router-dom'
import FormikInput from 'components/formikFields/input'
import Switch from 'react-switch'
import useUpdatePortion from '../../hooks/useUpdatePortion'
import DetactivateModal from 'components/modals/deactivate'
interface ItemProps {
    item: IMoneyPoolResults
    shareValueAmount: number
    setIsOpenPayToOtherModal: React.Dispatch<React.SetStateAction<boolean>>
    setSelectUser: React.Dispatch<
        React.SetStateAction<IMoneyPoolResults | undefined>
    >
    isManager: boolean
    refetch: () => void
}
export default function Item({
    item,
    shareValueAmount,
    setIsOpenPayToOtherModal,
    setSelectUser,
    isManager,
    refetch,
}: ItemProps) {
    const navigate = useNavigate()
    const [isOpenShereModal, setIsOpenShareModal] = useState<boolean>(false)
    const [isOpenChangePrice, setIsOpenChangePrice] = useState<boolean>(false)
    const [isPend, setIsPend] = useState<boolean>(true)
    const [isDeactive, setIsDeactive] = useState<boolean>(false)

    const { mutate } = useUpdatePortion(refetch)
    const { id } = useParams()
    const [isMe, setIsMe] = useState<boolean>(false)

    const profile = JSON.parse(localStorage.getItem('profile')!)
    useEffect(() => {
        if (profile) {
            if (profile.id === item.member.id) {
                setIsMe(true)
            }
        }
    }, [profile])

    return (
        <>
            {item && (
                <div
                    className={classNames(
                        item.portion_payment_status === 'ps_overpaid' &&
                            'bg-header-bg',
                        item.portion_payment_status === 'ps_paid' &&
                            ' bg-header-bg',
                        item.portion_payment_status === 'ps_unpaid' &&
                            'border border-gray-4',
                        item.portion_payment_status === 'ps_delayed' &&
                            'border border-gray-4',
                        'rounded-md  mx-4 , py-2 px-2 my-2 cursor-pointer'
                    )}
                    onClick={() =>
                        navigate(
                            `/fund/financial-history/${item.moneypool}/${item.id}`,
                            { state: { shareValueAmount } }
                        )
                    }
                >
                    <div className=" flex justify-between items-center">
                        <div>
                            <p>
                                {item?.member?.first_name}{' '}
                                {item?.member?.last_name} -{' '}
                                {item.number_of_shares} سهم{' '}
                                {item.role === 'own' && (
                                    <span className=" px-1 rounded-md bg-main-bg text-sm">
                                        ایجادکننده
                                    </span>
                                )}
                                {item.role === 'mgr' && (
                                    <span className=" px-1 rounded-md bg-main-bg text-sm">
                                        مدیر
                                    </span>
                                )}
                            </p>
                        </div>
                        <div
                            className={classNames(
                                item.portion_payment_status === 'ps_delayed' ||
                                    item.portion_payment_status === 'ps_unpaid'
                                    ? ''
                                    : ' my-3'
                            )}
                            onClick={(event) => {
                                event.stopPropagation()
                            }}
                        >
                            <CustomDropDown listWrapperClassName="w-[188px] top-4  absolute">
                                <div>
                                    <p
                                        onClick={() =>
                                            navigate(
                                                `/fund/financial-history/${item.moneypool}/${item.id}`,
                                                { state: { shareValueAmount } }
                                            )
                                        }
                                    >
                                        اطلاعات بیشتر
                                    </p>
                                    {isManager && (
                                        <>
                                            <hr className=" my-2" />
                                            <p
                                                onClick={() =>
                                                    setIsOpenShareModal(true)
                                                }
                                            >
                                                تغییر تعداد سهم
                                            </p>
                                            <hr className=" my-2" />
                                            <p
                                                onClick={() =>
                                                    setIsOpenChangePrice(true)
                                                }
                                            >
                                                تغییر مبلغ تعهدات
                                            </p>
                                            {!isMe && (
                                                <>
                                                    <hr className=" my-2" />
                                                    <p
                                                        onClick={() =>
                                                            setIsDeactive(true)
                                                        }
                                                    >
                                                        عیرفعال سازی
                                                    </p>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            </CustomDropDown>
                        </div>
                    </div>
                    <div className="flex justify-between">
                        {item.portion_payment_status === 'ps_delayed' && (
                            <span className=" bg-red-1 text-white rounded-md px-2 col-span-2 text-xs mt-2 py-1">
                                تاخیر در پرداخت:{' '}
                                {item.unpaid_portion &&
                                    item.unpaid_portion.toLocaleString()}{' '}
                                تومان
                            </span>
                        )}
                        {item.portion_payment_status === 'ps_unpaid' && (
                            <span className=" bg-main-bg rounded-sm px-2 col-span-2 text-xs mt-2">
                                پرداخت نشده:{' '}
                                {item.to_be_paid_portion &&
                                    item.to_be_paid_portion.toLocaleString()}{' '}
                                تومان
                            </span>
                        )}

                        {item.portion_payment_status === 'ps_delayed' ||
                        item.portion_payment_status === 'ps_unpaid' ? (
                            <div className=" bg-green-1 rounded-md flex px-1 text-white mt-2">
                                <p
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        setIsOpenPayToOtherModal(true)
                                        setSelectUser(item)
                                    }}
                                >
                                    پرداخت
                                </p>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            )}
            <ChangeShareModal
                show={isOpenShereModal}
                onHide={() => setIsOpenShareModal(false)}
                user={item}
            />

            <CustomBottomSheet
                isOpen={isOpenChangePrice}
                onDismiss={() => setIsOpenChangePrice(false)}
            >
                <>
                    <p className=" text-center text-gray-1">
                        تغییر مبلغ تعهدات
                    </p>
                    <hr className=" my-2" />
                    <Formik
                        initialValues={{
                            amount: item.to_be_paid_portion
                                ? item.to_be_paid_portion
                                : '',
                        }}
                        onSubmit={async (values) => {
                            console.log('1')
                            const payload: {
                                moneyPool: String | undefined
                                poolship: number
                                amount: number
                                is_delayed: boolean
                            } = {
                                moneyPool: id,
                                poolship: item.id,
                                amount: Number(values.amount),
                                is_delayed: isPend,
                            }
                            console.log('pYLOd', payload)
                            mutate(payload)
                            setIsOpenChangePrice(false)
                        }}
                        enableReinitialize
                    >
                        {({ values, touched, errors, setFieldValue }) => (
                            <Form className=" mx-4 my-2">
                                <NumericFormat
                                    customInput={FormikInput}
                                    thousandSeparator
                                    allowNegative={false}
                                    label=""
                                    name="amount"
                                    placeholder="مبلغ قابل پرداخت (تومان)"
                                    className="text-sm font-normal my-2"
                                    defaultValue={values.amount}
                                    onValueChange={(values) => {
                                        const { value } = values
                                        setFieldValue('amount', value)
                                    }}
                                />
                                <div className=" w-full flex my-3 items-center">
                                    <Switch
                                        onChange={() => setIsPend(!isPend)}
                                        checked={isPend}
                                        onColor="#75B844"
                                        onHandleColor="#EAEEF0"
                                        handleDiameter={25}
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        activeBoxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                        height={20}
                                        width={50}
                                        className="react-switch"
                                        id="material-switch"
                                        offColor="#B6BCC8"
                                    />
                                    <p className=" text-sm mx-2 text-gray-1">
                                        تاخیر در پرداخت
                                    </p>
                                </div>
                                <div className=" w-full flex justify-between">
                                    <button
                                        type="submit"
                                        className=" text-white bg-green-1 rounded-md w-full ml-1 py-2"
                                    >
                                        تایید
                                    </button>
                                    <button
                                        onClick={() =>
                                            setIsOpenChangePrice(false)
                                        }
                                        className=" text-green-1 border-1 border-green-1 rounded-md w-full py-2 mr-1"
                                    >
                                        انصراف
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </>
            </CustomBottomSheet>
            <DetactivateModal
                show={isDeactive}
                onHide={() => setIsDeactive(false)}
                user={item}
                refetch={refetch}
            />
        </>
    )
}
